<script lang="ts">
    import type {AvailableSize} from './types';
    import KpLoadingImg from './KpLoadingImg.svelte';

    export let showWhen = true;
    export let size: AvailableSize = 'md';
</script>

<template>
    <span class="kp-loading-wrapper" class:hidden={!showWhen}>
        <KpLoadingImg {size}/>
        <slot></slot>
    </span>
</template>

<style lang="less">
  .hidden {
    display: none;
  }
</style>